import {
    PM_USERS_FORCE_LOGOUT_OPEN_MODAL,
    PM_USERS_FORCE_LOGOUT_REQUEST,
    PM_USERS_FORCE_LOGOUT_RESULT
} from 'Redux/actionTypes';

export const pmUserForceLogoutOpenModal = (open, user) => ({
    type: PM_USERS_FORCE_LOGOUT_OPEN_MODAL,
    payload: { open, user }
});

export const pmUserForceLogoutRequest = (data) => ({
    type: PM_USERS_FORCE_LOGOUT_REQUEST,
    payload: data
});

export const pmUserForceLogoutResult = (result) => ({
    type: PM_USERS_FORCE_LOGOUT_RESULT,
    payload: result
});


